<template>
  <div class="hidden-sm-and-down">
    <v-layout row class="layout pr-4 pl-2 app--page-header" justify-center align-center>
      <div class="page-header-left">
        <h4 class="pr-3 font-weight-medium">{{ title }}</h4>
      </div>

      <div v-if="breadcrumbs.length" style="display: flex;" class="hidden-md-and-down">
        <v-btn flat icon to="/" div>
          <v-icon small>home</v-icon>
        </v-btn>
        <v-icon small>chevron_right</v-icon>
      </div>
      <v-breadcrumbs :items="breadcrumbs" divider="-" class="hidden-md-and-down">
        <template slot="item" slot-scope="props">
          <div v-if="!getLink(props.item)">{{ props.item }}</div>
          <router-link v-else :to="{ path: '/' + getLink(props.item) }" class="path-link">{{ props.item }}</router-link>
        </template>
      </v-breadcrumbs>
    </v-layout>
  </div>
</template>

<script>
  // import menu from '@/api/menu';
  import { mapGetters, mapActions } from 'vuex';
  export default {
    data() {
      return {
        title: null,
      };
    },
    computed: {
      ...mapGetters(['menus']),
      breadcrumbs: function () {
        let breadcrumbs = [];
        this.menus.forEach((item) => {
          if (item.items) {
            let child = item.items.find((i) => {
              const routeParts = this.$route.name.split('/');
              const componentParts = i.component.split('/');
              return componentParts[0] === routeParts[0] && componentParts[componentParts.length - 1] === routeParts[routeParts.length - 1];
              // return i.component === this.$route.name;
            });
            if (child) {
              this.title = child.title;
              breadcrumbs.push(item.title);
              breadcrumbs.push(child.title);
            }
          } else {
            if (item.name === this.$route.name) {
              this.title = item.title;
              breadcrumbs.push(item.title);
            }
          }
        });
        if (!breadcrumbs.length) {
          const routeParts = this.$route.name.split('/');
          this.title = routeParts[routeParts.length - 1].charAt(0).toUpperCase() + routeParts[routeParts.length - 1].slice(1);
          routeParts.forEach((element) => {
            breadcrumbs.push(element.charAt(0).toUpperCase() + element.slice(1));
          });
        }
        return breadcrumbs;
      },
    },
    methods: {
      getLink(item) {
        if (this.breadcrumbs.indexOf(item) < this.breadcrumbs.length - 1) {
          let path = null;
          if (this.breadcrumbs.indexOf(item) == 0) {
            path = this.breadcrumbs[this.breadcrumbs.indexOf(item)].toLowerCase();
          } else {
            path = this.breadcrumbs[this.breadcrumbs.indexOf(item) - 1].toLowerCase() + '/' + this.breadcrumbs[this.breadcrumbs.indexOf(item)].toLowerCase();
          }
          const routeName = this.$router.resolve({ name: path });
          if (routeName && routeName.href !== '/') {
            return path;
          } else {
            return null;
          }
        }
      },
    },
  };
</script>

<style>
  .theme--dark.v-breadcrumbs .v-breadcrumbs__divider {
    color: white;
  }
  a.path-link {
    color: #fff;
  }
</style>
